export default __webpack_public_path__ + "static/2-958cf103ed53516a8fe5afd11b80ffda.webp";